import { FLUENT_TOOLS, ToolEnum, USED_TOOLS, LOGO_ICONS } from "./config";
import "./skills.css";
import { SectionProps } from "../../App";

const Skills = ({ observeElement }: SectionProps) => {
  // Generates block element contaning icon and its name.
  const getLogoElement = (tool: ToolEnum) => {
    const { icon, name } = LOGO_ICONS[tool];
    return (
      <div
        className="skills__icon"
        key={tool}
      >
        <img
          src={icon}
          alt={tool}
          className={`skills__icon-${tool}`}
        />
        <div>{name}</div>
      </div>
    );
  };

  return (
    <section id="skills">
      <h2>Skills</h2>
      <div className="container skills__container">
        <div
          className="skills__content"
          ref={observeElement}
        >
          <p>
            {"Here are some of the programming languages and frameworks " +
              "I have used in the past. Hit me up if I have the " +
              "skillsets you are looking for!"}
          </p>
          <a
            href="#contact"
            className="btn btn-primary"
            ref={observeElement}
          >
            Hit Me Up!
          </a>
        </div>

        <div className="skills__cards">
          <article
            className="skills__card"
            ref={observeElement}
          >
            <div className="skills__title">{"Fluent in"}</div>
            <div className="skills__icons">
              {FLUENT_TOOLS.map(getLogoElement)}
            </div>
          </article>

          <article
            className="skills__card"
            ref={observeElement}
          >
            <div className="skills__title">{"Also used"}</div>
            <div className="skills__icons">
              {USED_TOOLS.map(getLogoElement)}
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Skills;
